import { render, staticRenderFns } from "./ServiceDetailSearch.vue?vue&type=template&id=65e603b0"
import script from "./ServiceDetailSearch.vue?vue&type=script&lang=js"
export * from "./ServiceDetailSearch.vue?vue&type=script&lang=js"
import style0 from "./ServiceDetailSearch.vue?vue&type=style&index=0&id=65e603b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports